import React from "react";
import { useHistory } from "react-router-dom";
import empaticaLogo from "../recursos/empatica-hor.png";

const BLUE = "#0A5CFF";
const BLUE_DARK = "#063AA8";
const INK = "#0B1220";
const MUTED = "#667085";
const BORDER = "#E4E7EC";
const SOFT = "#F6F8FC";
const SUCCESS = "#16A36A";
const WARNING = "#C47A00";

export default function ApiIntegraciones() {
  const history = useHistory();

  const goTo = (path) => {
    window.open(path, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <style>{`
        * { box-sizing: border-box; }

        html { scroll-behavior: smooth; }

        body {
          margin: 0;
          background: #ffffff;
          color: ${INK};
        }

        .apiHub {
          min-height: 100vh;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          background:
            radial-gradient(circle at 10% 5%, rgba(10,92,255,.08), transparent 24%),
            radial-gradient(circle at 90% 0%, rgba(32,166,255,.05), transparent 28%),
            linear-gradient(180deg, #F7FAFF 0%, #FFFFFF 34%, #FFFFFF 100%);
        }

        .apiTopbar {
          height: 72px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 6vw;
          border-bottom: 1px solid rgba(228,231,236,.85);
          background: rgba(255,255,255,.90);
          backdrop-filter: blur(16px);
          position: sticky;
          top: 0;
          z-index: 50;
        }

        .brand {
          display: flex;
          align-items: center;
          gap: 14px;
          cursor: default;
        }

        .brandLogo {
          height: 34px;
          width: auto;
          display: block;
          object-fit: contain;
        }

        .brandText {
          line-height: 1.05;
        }

        .brandSub {
          color: ${MUTED};
          font-size: 12px;
          margin-top: 4px;
          font-weight: 600;
        }

        .topLink {
          border: 0;
          background: transparent;
          color: ${MUTED};
          font-weight: 700;
          cursor: pointer;
          padding: 10px 14px;
          border-radius: 10px;
          transition: .2s ease;
        }

        .topLink:hover {
          color: ${BLUE};
          background: #F0F5FF;
        }

        .apiHub .hero {
          max-width: 1180px;
          margin: 0 auto;
          padding: 34px 24px 8px;
          min-height: 0 !important;
          height: auto !important;
          text-align: center;
        }

        .eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 8px 12px;
          border-radius: 999px;
          background: #EDF4FF;
          color: ${BLUE_DARK};
          font-size: 12px;
          font-weight: 800;
          letter-spacing: .08em;
          text-transform: uppercase;
          border: 1px solid #D8E7FF;
        }

        .eyebrowDot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: ${BLUE};
          box-shadow: 0 0 0 5px rgba(10,92,255,.10);
        }

        .heroTitle {
          max-width: 920px;
          margin: 20px auto 16px;
          line-height: .98;
          letter-spacing: -.055em;
          font-weight: 850;
        }

        .heroTitleTop {
          display: block;
          font-size: clamp(34px, 5vw, 58px);
          color: #1E293B;
        }

        .heroTitleBottom {
          display: block;
          font-size: clamp(48px, 7vw, 76px);
          color: ${BLUE};
          margin-top: 4px;
        }

        .apiHub .hero p {
          max-width: 760px;
          margin: 0 auto;
          color: ${MUTED};
          font-size: clamp(17px, 2vw, 20px);
          line-height: 1.65;
        }

        .choiceNote {
          display: inline-flex;
          align-items: center;
          gap: 9px;
          margin-top: 16px;
          color: #475467;
          font-size: 13px;
          font-weight: 700;
        }

        .choiceNote svg {
          color: ${BLUE};
        }

        .apiHub .models {
          max-width: 1180px;
          margin: 0 auto;
          padding: 4px 24px 52px;
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 24px;
          align-items: start;
        }

        .apiHub .modelCard {
          position: relative;
          overflow: hidden;
          height: auto !important;
          min-height: 0 !important;
          max-height: none !important;
          align-self: start;
          border: 1px solid ${BORDER};
          border-radius: 26px;
          background: rgba(255,255,255,.96);
          box-shadow: 0 18px 60px rgba(16,24,40,.08);
          transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease;
        }

        .apiHub .modelCard:hover {
          transform: translateY(-6px);
          border-color: #B7CDFE;
          box-shadow: 0 24px 75px rgba(16,24,40,.13);
        }

        .apiHub .cardAccent {
          height: 5px;
          background: linear-gradient(90deg, ${BLUE}, #57B3FF);
          border-radius: 26px 26px 0 0;
        }

        .apiHub .deviceCard .cardAccent {
          background: linear-gradient(90deg, #172554, #5166D9);
        }

        .apiHub .cardBody {
          padding: 30px 30px 34px;
          display: block;
          height: auto !important;
          min-height: 0 !important;
          max-height: none !important;
        }

        .cardTop {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 18px;
          margin-bottom: 10px;
        }

        .apiHeaderLeft {
          display: inline-flex;
          align-items: center;
          gap: 0;
          min-width: 0;
        }

        .apiIdentity {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 8px 14px 8px 10px;
          border-radius: 18px;
          background: #EDF4FF;
          min-height: 52px;
        }

        .apiIdentity.device {
          background: #EEF0FF;
        }

        .apiIcon {
          width: 32px;
          height: 32px;
          border-radius: 12px;
          display: grid;
          place-items: center;
          background: rgba(255,255,255,.55);
          color: ${BLUE};
          flex: 0 0 auto;
        }

        .deviceCard .apiIcon {
          background: rgba(255,255,255,.55);
          color: #3549C8;
        }

        .badge {
          padding: 7px 10px;
          border-radius: 999px;
          background: #F2F4F7;
          color: #475467;
          font-size: 11px;
          font-weight: 800;
          letter-spacing: .05em;
          text-transform: uppercase;
          white-space: nowrap;
        }

        .apiNameTag {
          display: inline-flex;
          align-items: center;
          padding: 0;
          border-radius: 0;
          font-size: 11px;
          font-weight: 800;
          letter-spacing: .05em;
          text-transform: uppercase;
          align-self: auto;
          white-space: nowrap;
          background: transparent;
        }

        .apiNameTag.connect {
          background: #EAF2FF;
          color: #0A5CFF;
        }

        .apiNameTag.device {
          background: #EEF0FF;
          color: #3549C8;
        }

        .apiHub .modelCard h2 {
          margin: 24px 0 6px;
          font-size: 30px;
          letter-spacing: -.035em;
        }

        .tagline {
          margin: 0;
          color: #344054;
          font-size: 17px;
          font-weight: 700;
        }

        .description {
          color: ${MUTED};
          line-height: 1.7;
          margin: 14px 0 24px;
          min-height: 82px;
        }

        .architecture {
          border: 1px solid ${BORDER};
          background: ${SOFT};
          border-radius: 18px;
          padding: 18px;
          margin: 22px 0;
        }

        .archLabel {
          color: #667085;
          font-size: 11px;
          font-weight: 800;
          letter-spacing: .08em;
          text-transform: uppercase;
          margin-bottom: 14px;
        }

        .flow {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          flex-wrap: wrap;
        }

        .node {
          background: #fff;
          border: 1px solid #D0D5DD;
          border-radius: 12px;
          padding: 10px 12px;
          font-size: 12px;
          font-weight: 800;
          text-align: center;
          min-width: 94px;
        }

        .nodePrimary {
          border-color: #9BBEFF;
          background: #EEF4FF;
          color: ${BLUE_DARK};
        }

        .nodeDevice {
          border-color: #B8C0FF;
          background: #F0F1FF;
          color: #2638A4;
        }

        .arrow {
          color: #98A2B3;
          font-weight: 900;
          font-size: 17px;
        }

        .miniStack {
          display: grid;
          gap: 6px;
        }

        .miniNode {
          border: 1px solid #CFD9F8;
          background: #fff;
          border-radius: 9px;
          padding: 6px 10px;
          font-size: 10px;
          font-weight: 800;
        }

        .archNote {
          margin-top: 14px;
          color: #667085;
          font-size: 12px;
          line-height: 1.5;
          text-align: center;
        }

        .features {
          display: grid;
          gap: 11px;
          margin: 22px 0;
        }

        .feature {
          display: flex;
          align-items: flex-start;
          gap: 11px;
          color: #344054;
          font-size: 14px;
          line-height: 1.45;
        }

        .check {
          width: 22px;
          height: 22px;
          flex: 0 0 22px;
          border-radius: 50%;
          display: grid;
          place-items: center;
          background: #ECFDF3;
          color: ${SUCCESS};
          font-size: 12px;
          font-weight: 900;
          margin-top: 1px;
        }

        .tradeoff {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          padding: 12px 14px;
          border-radius: 13px;
          background: #FFF9EC;
          color: #73510D;
          font-size: 13px;
          line-height: 1.5;
          margin-bottom: 22px;
        }

        .tradeoff strong {
          color: #5B3B00;
        }

        .priceLine {
          margin: 0 0 14px;
          color: #667085;
          font-size: 12px;
          line-height: 1.4;
        }

        .priceLine strong {
          color: #344054;
          font-size: 13px;
          font-weight: 800;
        }

        .apiHub .cta {
          width: 100%;
          min-height: 50px;
          position: relative;
          bottom: auto !important;
          top: auto !important;
          transform: none;
          border: 0;
          border-radius: 14px;
          color: white;
          background: ${BLUE};
          font-size: 14px;
          font-weight: 800;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 9px;
          transition: transform .18s ease, filter .18s ease;
        }

        .apiHub .cta:hover {
          transform: translateY(-1px);
          filter: brightness(.96);
        }

        .deviceCard .apiHub .cta {
          background: #2638A4;
        }

        .compareSection {
          max-width: 1180px;
          margin: 0 auto;
          padding: 10px 24px 88px;
        }

        .sectionTitle {
          text-align: center;
          max-width: 720px;
          margin: 0 auto 24px;
        }

        .sectionTitle h3 {
          margin: 0;
          font-size: 32px;
          letter-spacing: -.035em;
        }

        .sectionTitle p {
          margin: 10px auto 0;
          color: ${MUTED};
          line-height: 1.6;
        }

        .compareBox {
          overflow: hidden;
          border: 1px solid ${BORDER};
          border-radius: 22px;
          background: #fff;
          box-shadow: 0 15px 50px rgba(16,24,40,.06);
        }

        .compareRow {
          display: grid;
          grid-template-columns: 1.15fr 1fr 1fr;
          border-bottom: 1px solid ${BORDER};
        }

        .compareRow:last-child { border-bottom: 0; }

        .compareRow > div {
          padding: 18px 20px;
          font-size: 14px;
          line-height: 1.45;
        }

        .compareRow > div:not(:first-child) {
          border-left: 1px solid ${BORDER};
        }

        .compareHead {
          background: #F8FAFC;
          font-weight: 800;
          color: #0F172A;
        }

        .compareLabel {
          color: #344054;
          font-weight: 750;
        }

        .compareValue {
          color: #667085;
        }

        .footer {
          border-top: 1px solid ${BORDER};
          padding: 28px 24px 36px;
          text-align: center;
          color: #98A2B3;
          font-size: 12px;
        }

        @media (max-width: 860px) {
          .apiTopbar { padding: 0 20px; }
          .apiHub .hero { padding-top: 28px; padding-bottom: 8px; }
          .apiHub .models { grid-template-columns: 1fr; }
          .description { min-height: auto; }
          .compareRow {
            grid-template-columns: 1fr;
            padding: 14px 0;
          }
          .compareRow > div {
            padding: 8px 18px;
          }
          .compareRow > div:not(:first-child) {
            border-left: 0;
          }
          .compareHead { display: none; }
          .compareValue::before {
            display: block;
            font-size: 10px;
            color: #98A2B3;
            font-weight: 800;
            letter-spacing: .06em;
            text-transform: uppercase;
            margin-bottom: 4px;
          }
          .compareValue.connect::before { content: "Connect API"; }
          .compareValue.device::before { content: "Device API"; }
        }

        @media (max-width: 540px) {
          .brandSub { display: none; }
          .topLink { display: none; }
          .heroTitleTop { font-size: 34px; }
          .heroTitleBottom { font-size: 52px; }
          .apiHub .hero p { font-size: 16px; }
          .apiHub .models { padding-left: 16px; padding-right: 16px; }
          .apiHub .cardBody { padding: 23px; }
          .apiHub .modelCard h2 { font-size: 27px; }
          .flow { justify-content: flex-start; }
          .compareSection { padding-left: 16px; padding-right: 16px; }
          .brandLogo { height: 28px; }
        }

        /* ===== Responsive estable ===== */
        html, body {
          max-width: 100%;
          overflow-x: hidden;
        }

        .apiHub,
        .apiHub * {
          min-width: 0;
        }

        @media (max-width: 1024px) {
          .apiTopbar {
            padding: 0 24px;
          }

          .apiHub .hero {
            padding-left: 22px;
            padding-right: 22px;
          }

          .apiHub .models {
            grid-template-columns: 1fr;
            max-width: 760px;
            gap: 22px;
          }

          .description {
            min-height: 0;
          }

          .compareSection {
            max-width: 760px;
          }
        }

        @media (max-width: 760px) {
          .apiTopbar {
            height: 64px;
            padding: 0 16px;
          }

          .brand {
            gap: 10px;
          }

          .brandLogo {
            height: 28px;
          }

          .brandSub {
            font-size: 10px;
          }

          .topLink {
            padding: 8px 10px;
            font-size: 12px;
          }

          .apiHub .hero {
            padding: 26px 16px 10px;
          }

          .eyebrow {
            padding: 7px 10px;
            font-size: 10px;
          }

          .heroTitle {
            margin-top: 16px;
            margin-bottom: 14px;
            line-height: 1.02;
          }

          .heroTitleTop {
            font-size: clamp(30px, 8vw, 42px);
          }

          .heroTitleBottom {
            font-size: clamp(42px, 12vw, 58px);
          }

          .apiHub .hero p {
            font-size: 15px;
            line-height: 1.6;
          }

          .choiceNote {
            max-width: 100%;
            align-items: flex-start;
            text-align: left;
            font-size: 12px;
            line-height: 1.45;
          }

          .apiHub .models {
            padding: 8px 16px 40px;
            gap: 18px;
          }

          .apiHub .modelCard {
            border-radius: 20px;
          }

          .apiHub .cardAccent {
            border-radius: 20px 20px 0 0;
          }

          .apiHub .cardBody {
            padding: 22px 18px 24px;
          }

          .cardTop {
            display: grid;
            grid-template-columns: 1fr;
            align-items: start;
            justify-items: start;
            gap: 10px;
            margin-bottom: 14px;
          }

          .apiHeaderLeft {
            width: 100%;
          }

          .apiIdentity {
            width: 100%;
            justify-content: flex-start;
            min-height: 48px;
            border-radius: 15px;
          }

          .badge {
            max-width: 100%;
            white-space: normal;
            line-height: 1.35;
            font-size: 9px;
          }

          .apiHub .modelCard h2 {
            margin-top: 18px;
            font-size: 27px;
          }

          .tagline {
            font-size: 15px;
            line-height: 1.45;
          }

          .description {
            margin-top: 12px;
            margin-bottom: 18px;
            font-size: 14px;
            line-height: 1.6;
          }

          .architecture {
            padding: 15px;
            margin: 18px 0;
          }

          .flow {
            flex-direction: column;
            align-items: stretch;
            justify-content: flex-start;
            gap: 8px;
          }

          .node,
          .miniStack,
          .miniNode {
            width: 100%;
            min-width: 0;
          }

          .miniStack {
            gap: 6px;
          }

          .arrow {
            width: 100%;
            text-align: center;
            transform: rotate(90deg);
            line-height: 1;
            padding: 2px 0;
          }

          .deviceCard .flow > span[style] {
            display: block !important;
            width: 100%;
            text-align: center;
            line-height: 1;
          }

          .features {
            margin: 18px 0;
            gap: 10px;
          }

          .feature {
            font-size: 13px;
          }

          .tradeoff {
            margin-bottom: 16px;
            font-size: 12px;
          }

          .priceLine {
            margin-bottom: 12px;
          }

          .apiHub .cta {
            min-height: 48px;
            padding: 10px 12px;
            font-size: 13px;
            text-align: center;
          }

          .compareSection {
            padding: 8px 16px 60px;
          }

          .sectionTitle {
            margin-bottom: 18px;
          }

          .sectionTitle h3 {
            font-size: 27px;
            line-height: 1.1;
          }

          .sectionTitle p {
            font-size: 14px;
          }

          .compareBox {
            border-radius: 18px;
          }

          .compareRow {
            display: block;
            padding: 0;
          }

          .compareHead {
            display: none;
          }

          .compareRow > div {
            padding: 10px 14px;
            border-left: 0 !important;
          }

          .compareLabel {
            padding-top: 14px !important;
            padding-bottom: 7px !important;
            background: #FAFBFD;
            font-size: 12px !important;
            border-bottom: 1px solid #EEF0F3;
          }

          .compareValue {
            font-size: 13px !important;
            padding-top: 11px !important;
            padding-bottom: 11px !important;
          }

          .compareValue::before {
            display: block;
            margin-bottom: 4px;
            color: #98A2B3;
            font-size: 9px;
            font-weight: 900;
            letter-spacing: .06em;
            text-transform: uppercase;
          }

          .compareValue.connect::before {
            content: "Connect API";
          }

          .compareValue.device::before {
            content: "Device API";
          }

          .footer {
            padding: 24px 16px 30px;
            font-size: 11px;
          }
        }

        @media (max-width: 480px) {
          .apiTopbar {
            padding: 0 12px;
          }

          .brandSub {
            display: none;
          }

          .topLink {
            font-size: 11px;
            padding: 7px 8px;
          }

          .apiHub .hero {
            padding-left: 13px;
            padding-right: 13px;
          }

          .apiHub .models,
          .compareSection {
            padding-left: 13px;
            padding-right: 13px;
          }

          .apiHub .cardBody {
            padding: 20px 15px 22px;
          }

          .apiIdentity {
            padding-right: 11px;
          }

          .apiIcon {
            width: 30px;
            height: 30px;
          }

          .apiHub .modelCard h2 {
            font-size: 25px;
          }

          .architecture {
            padding: 13px;
          }

          .feature {
            gap: 9px;
          }

          .check {
            width: 20px;
            height: 20px;
            flex-basis: 20px;
          }
        }


        /* ===== MOBILE FLOW FIX: evita solapes por estilos globales ===== */
        @media (max-width: 760px) {
          .apiHub main,
          .apiHub .hero,
          .apiHub .models,
          .apiHub .modelCard,
          .apiHub .cardBody,
          .apiHub .cardTop,
          .apiHub .architecture,
          .apiHub .flow,
          .apiHub .features,
          .apiHub .tradeoff,
          .apiHub .priceLine,
          .apiHub .compareSection,
          .apiHub .sectionTitle,
          .apiHub .compareBox,
          .apiHub .compareRow {
            position: static !important;
            top: auto !important;
            right: auto !important;
            bottom: auto !important;
            left: auto !important;
            transform: none !important;
            float: none !important;
            clear: both !important;
            height: auto !important;
            min-height: 0 !important;
            max-height: none !important;
          }

          .apiHub main {
            display: block !important;
            width: 100% !important;
            overflow: visible !important;
          }

          .apiHub .models {
            display: block !important;
            width: 100% !important;
            max-width: 100% !important;
            overflow: visible !important;
          }

          .apiHub .modelCard {
            display: block !important;
            width: 100% !important;
            max-width: 100% !important;
            overflow: hidden !important;
            margin: 0 0 20px !important;
            z-index: auto !important;
          }

          .apiHub .modelCard:hover {
            transform: none !important;
          }

          .apiHub .cardBody {
            display: flow-root !important;
            width: 100% !important;
            overflow: visible !important;
          }

          .apiHub .cardTop {
            display: grid !important;
          }

          .apiHub .architecture {
            display: block !important;
            width: 100% !important;
            overflow: hidden !important;
          }

          .apiHub .flow {
            display: flex !important;
            width: 100% !important;
            overflow: visible !important;
          }

          .apiHub .node,
          .apiHub .miniNode,
          .apiHub .miniStack,
          .apiHub .apiIdentity,
          .apiHub .apiHeaderLeft {
            position: static !important;
            transform: none !important;
            float: none !important;
            max-width: 100% !important;
          }

          .apiHub .features,
          .apiHub .tradeoff,
          .apiHub .priceLine,
          .apiHub .cta {
            width: 100% !important;
          }

          .apiHub .compareSection {
            display: block !important;
            width: 100% !important;
            max-width: 100% !important;
            margin-top: 8px !important;
            z-index: auto !important;
            overflow: visible !important;
          }

          .apiHub .sectionTitle {
            display: block !important;
            width: 100% !important;
            margin-top: 0 !important;
          }

          .apiHub .compareBox {
            display: block !important;
            width: 100% !important;
            overflow: hidden !important;
          }

          .apiHub .compareRow {
            display: block !important;
            width: 100% !important;
          }

          .apiHub .footer {
            position: static !important;
            clear: both !important;
          }
        }


        /* ===== AISLAMIENTO ESTRUCTURAL GLOBAL =====
           Evita choques con clases globales del sitio en cualquier resolución. */
        .apiHub main,
        .apiHub .hero,
        .apiHub .models,
        .apiHub .modelCard,
        .apiHub .cardBody,
        .apiHub .cardTop,
        .apiHub .apiHeaderLeft,
        .apiHub .apiIdentity,
        .apiHub .description,
        .apiHub .architecture,
        .apiHub .flow,
        .apiHub .node,
        .apiHub .miniStack,
        .apiHub .miniNode,
        .apiHub .features,
        .apiHub .feature,
        .apiHub .tradeoff,
        .apiHub .priceLine,
        .apiHub .compareSection,
        .apiHub .sectionTitle,
        .apiHub .compareBox,
        .apiHub .compareRow,
        .apiHub .footer {
          top: auto !important;
          right: auto !important;
          bottom: auto !important;
          left: auto !important;
          float: none !important;
          max-height: none !important;
        }

        .apiHub main {
          position: relative !important;
          display: block !important;
          width: 100% !important;
          overflow: visible !important;
        }

        .apiHub .hero {
          position: relative !important;
          clear: both !important;
        }

        .apiHub .models {
          position: relative !important;
          clear: both !important;
          height: auto !important;
          min-height: 0 !important;
          overflow: visible !important;
        }

        .apiHub .modelCard {
          position: relative !important;
          height: auto !important;
          min-height: 0 !important;
          max-height: none !important;
          overflow: hidden !important;
          z-index: 1 !important;
        }

        .apiHub .cardBody {
          position: relative !important;
          height: auto !important;
          min-height: 0 !important;
          max-height: none !important;
          overflow: visible !important;
        }

        .apiHub .cardTop,
        .apiHub .apiHeaderLeft,
        .apiHub .apiIdentity,
        .apiHub .description,
        .apiHub .architecture,
        .apiHub .flow,
        .apiHub .features,
        .apiHub .feature,
        .apiHub .tradeoff,
        .apiHub .priceLine {
          position: relative !important;
          height: auto !important;
          min-height: 0 !important;
        }

        .apiHub .compareSection {
          position: relative !important;
          display: block !important;
          clear: both !important;
          height: auto !important;
          min-height: 0 !important;
          margin-top: 0 !important;
          overflow: visible !important;
          z-index: 0 !important;
        }

        .apiHub .sectionTitle {
          position: relative !important;
          display: block !important;
          clear: both !important;
          height: auto !important;
          min-height: 0 !important;
          transform: none !important;
          z-index: auto !important;
        }

        .apiHub .sectionTitle h3,
        .apiHub .sectionTitle p {
          position: static !important;
          transform: none !important;
          height: auto !important;
          max-height: none !important;
        }

        .apiHub .compareBox {
          position: relative !important;
          display: block !important;
          clear: both !important;
          height: auto !important;
          min-height: 0 !important;
          transform: none !important;
          z-index: auto !important;
        }

        .apiHub .compareRow {
          position: relative !important;
          height: auto !important;
          min-height: 0 !important;
          transform: none !important;
        }

        /* Mantiene separación física entre cards y comparación en todos los anchos */
        .apiHub .models + .compareSection {
          padding-top: 28px !important;
        }

        /* Pantallas intermedias: evita comprimir dos cards hasta que ya no quepan bien */
        @media (max-width: 1180px) {
          .apiHub .models {
            grid-template-columns: 1fr !important;
            max-width: 760px !important;
          }

          .apiHub .compareSection {
            max-width: 760px !important;
          }
        }

        /* En móvil/tablet cada tarjeta es un bloque independiente de flujo */
        @media (max-width: 760px) {
          .apiHub .models {
            display: block !important;
          }

          .apiHub .modelCard {
            display: block !important;
            width: 100% !important;
            margin: 0 0 20px !important;
          }

          .apiHub .cardBody {
            display: flow-root !important;
          }

          .apiHub .compareSection {
            padding-top: 18px !important;
          }
        }


        /* Color protegido para la sección comparativa */
        .apiHub .sectionTitle h3 {
          color: #0B1220 !important;
        }

        .apiHub .sectionTitle p {
          color: #667085 !important;
        }

      `}</style>

      <div className="apiHub">
        <header className="apiTopbar">
          <div className="brand">
            <img
              src={empaticaLogo}
              alt="Empática"
              className="brandLogo"
            />
            <div className="brandText">
              <div className="brandSub">Developer Platform</div>
            </div>
          </div>

          <button className="topLink" onClick={() => history.push("/")}>
            Volver a Empática
          </button>
        </header>

        <main>
          <section className="hero">
            <div className="eyebrow">
              <span className="eyebrowDot" />
              APIs de integración
            </div>

            <h1 className="heroTitle">
              <span className="heroTitleTop">Elige tu modelo de</span>
              <span className="heroTitleBottom">integración</span>
            </h1>

            <p>
              Empática ofrece dos arquitecturas de integración dependiendo del
              nivel de control que necesite tu sistema. Integra el procesamiento
              de pagos de forma centralizada o controla directamente cada cajero.
            </p>

            <div className="choiceNote">
              <InfoIcon />
              Puedes elegir el modelo que mejor se adapte a tu arquitectura.
            </div>
          </section>

          <section className="models">
            <article className="modelCard">
              <div className="cardAccent" />
              <div className="cardBody">
                <div className="cardTop">
                  <div className="apiHeaderLeft">
                    <div className="apiIdentity">
                      <div className="apiIcon">
                        <CloudIcon />
                      </div>
                      <div className="apiNameTag connect">Connect API</div>
                    </div>
                  </div>
                  <span className="badge">Integración centralizada</span>
                </div>

                <h2>Connect API</h2>
                <p className="tagline">
                  Integra una vez y conecta múltiples cajeros.
                </p>

                <p className="description">
                  Tu sistema se comunica con el servidor de Empática. Desde una
                  sola integración puedes enviar ventas y recibir la confirmación
                  de pago de uno o varios cajeros conectados.
                </p>

                <div className="architecture">
                  <div className="archLabel">Arquitectura</div>
                  <div className="flow">
                    <div className="node">Sistema integrador</div>
                    <div className="arrow">→</div>
                    <div className="node nodePrimary">Servidor</div>
                    <div className="arrow">→</div>
                    <div className="miniStack">
                      <div className="miniNode">Cajero 1</div>
                      <div className="miniNode">Cajero 2</div>
                      <div className="miniNode">Cajero N</div>
                    </div>
                  </div>
                  <div className="archNote">
                    Puede operar desde nube o desde un servidor local.
                  </div>
                </div>

                <div className="features">
                  <Feature>Integración centralizada con implementación más simple.</Feature>
                  <Feature>Una sola integración para conectar uno o múltiples cajeros.</Feature>
                  <Feature>
                    Generación de ventas, código de pago y confirmación por webhook.
                  </Feature>
                  <Feature>
                    Ideal para sistemas que buscan gestionar transacciones y mantener la operación del cajero por separado.
                  </Feature>
                </div>

                <div className="tradeoff">
                  <WarningIcon />
                  <div>
                    <strong>Consideración:</strong> el control operativo es parcial.
                    Dotaciones, cortes y balances se realizan desde la interfaz
                    nativa del cajero.
                  </div>
                </div>

                <div className="priceLine">
                  Precio actual: <strong>$0 MXN / mes</strong>
                </div>

                <button className="cta" onClick={() => goTo("/developers/connect-api")}>
                  Ver documentación de Connect API
                  <ArrowIcon />
                </button>
              </div>
            </article>

            <article className="modelCard deviceCard">
              <div className="cardAccent" />
              <div className="cardBody">
                <div className="cardTop">
                  <div className="apiHeaderLeft">
                    <div className="apiIdentity device">
                      <div className="apiIcon">
                        <DeviceIcon />
                      </div>
                      <div className="apiNameTag device">Device API</div>
                    </div>
                  </div>
                  <span className="badge">Integración directa</span>
                </div>

                <h2>Device API</h2>
                <p className="tagline">
                  Conecta directamente con el cajero y controla sus funciones.
                </p>

                <p className="description">
                  Tu sistema consume directamente los servicios expuestos por cada
                  cajero. Además de procesar pagos, puede ejecutar y consultar
                  funciones operativas del dispositivo.
                </p>

                <div className="architecture">
                  <div className="archLabel">Arquitectura</div>
                  <div className="flow">
                    <div className="node">Sistema integrador</div>
                    <div className="arrow">→</div>
                    <div className="node nodeDevice">Cajero 1</div>
                    <span style={{ color: "#98A2B3", fontWeight: 800 }}>+</span>
                    <div className="node nodeDevice">Cajero 2</div>
                  </div>
                  <div className="archNote">
                    Requiere comunicación local directa en la misma red del cajero.
                  </div>
                </div>

                <div className="features">
                  <Feature>Conexión directa con cada cajero.</Feature>
                  <Feature>Procesamiento de pagos desde tu sistema.</Feature>
                  <Feature>Acceso a funciones operativas como dotaciones, cortes y balance.</Feature>
                  <Feature>
                    Ideal cuando la administración del cajero y la operación deben vivir dentro de tu propia plataforma.
                  </Feature>
                </div>

                <div className="tradeoff">
                  <WarningIcon />
                  <div>
                    <strong>Consideración:</strong> requiere mayor desarrollo y una
                    conexión individual con cada cajero que será administrado.
                  </div>
                </div>

                <div className="priceLine">
                  Precio actual: <strong>$0 MXN / mes</strong>
                </div>

                <button className="cta" onClick={() => goTo("/developers/device-api")}>
                  Ver documentación de Device API
                  <ArrowIcon />
                </button>
              </div>
            </article>
          </section>

          <section className="compareSection">
            <div className="sectionTitle">
              <h3>¿Cuál integración necesito?</h3>
              <p>
                La diferencia principal está en el modelo de comunicación, la ubicación del sistema integrador y el tipo de operación que deseas gestionar.
              </p>
            </div>

            <div className="compareBox">
              <div className="compareRow compareHead">
                <div>Característica</div>
                <div>Connect API</div>
                <div>Device API</div>
              </div>

              <CompareRow
                label="Modelo de comunicación"
                connect="Centralizado mediante Servidor"
                device="Directo con cada cajero"
              />
              <CompareRow
                label="Ubicación del sistema integrador"
                connect="Nube o servidor local"
                device="Misma red local del cajero"
              />
              <CompareRow
                label="Cantidad de integraciones"
                connect="Una integración para uno o múltiples cajeros"
                device="Una conexión por cada equipo"
              />
              <CompareRow
                label="Procesamiento de pagos"
                connect="Sí"
                device="Sí"
              />
              <CompareRow
                label="Confirmación de pago"
                connect="Webhook / Postback"
                device="Respuesta y eventos directos"
              />
              <CompareRow
                label="Operación del cajero"
                connect="Funciones operativas desde la interfaz del cajero"
                device="Funciones operativas disponibles mediante API"
              />
              <CompareRow
                label="Enfoque de integración"
                connect="Gestión centralizada de transacciones"
                device="Gestión directa del dispositivo"
              />
            </div>
          </section>
        </main>

        <footer className="footer">
          Empática Developer Platform · Integración con soluciones de autocobro
        </footer>
      </div>
    </>
  );
}

function Feature({ children }) {
  return (
    <div className="feature">
      <div className="check">✓</div>
      <div>{children}</div>
    </div>
  );
}

function CompareRow({ label, connect, device }) {
  return (
    <div className="compareRow">
      <div className="compareLabel">{label}</div>
      <div className="compareValue connect">{connect}</div>
      <div className="compareValue device">{device}</div>
    </div>
  );
}

function CloudIcon() {
  return (
    <svg width="27" height="27" viewBox="0 0 24 24" fill="none">
      <path
        d="M7.5 18H17a4 4 0 0 0 .77-7.93A6 6 0 0 0 6.23 8.65 4.7 4.7 0 0 0 7.5 18Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 13h6M12 10v6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function DeviceIcon() {
  return (
    <svg width="27" height="27" viewBox="0 0 24 24" fill="none">
      <rect
        x="5"
        y="2.8"
        width="14"
        height="18.4"
        rx="2.5"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M8 6.5h8M8 10h8M8 13.5h5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <circle cx="15.7" cy="17.3" r="1.3" fill="currentColor" />
    </svg>
  );
}

function ArrowIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
      <path
        d="M5 12h14M14 7l5 5-5 5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function InfoIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M12 10.8V16M12 8h.01"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function WarningIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      style={{ flex: "0 0 20px", marginTop: 1, color: WARNING }}
    >
      <path
        d="M12 4 21 20H3L12 4Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M12 9v5M12 17.2h.01"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
